import { Link } from 'react-router-dom';

export default function GameIntro() {
  return (
    <section className="py-14 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-14">
          <div className="w-full lg:w-1/2">
            <img
              src="https://readdy.ai/api/search-image?query=A%20cute%20adventurer%20character%20jumping%20on%20top%20of%20a%20large%20red%20mushroom%20in%20a%20whimsical%20forest%20setting%2C%20surrounded%20by%20smaller%20mushrooms%20and%20sparkles%2C%20hand-drawn%20game%20illustration%20style%2C%20bright%20cheerful%20colors%2C%20soft%20warm%20lighting%20through%20trees%2C%20playful%20atmosphere%2C%20character%20with%20a%20backpack%20and%20adventure%20hat%20looking%20determined%2C%20floating%20leaves%20in%20the%20air%2C%20storybook%20art%20style%20with%20gentle%20textures&width=800&height=600&seq=intro-mushroom-02&orientation=landscape"
              alt="踩蘑菇游戏介绍"
              className="w-full h-auto rounded-2xl"
            />
          </div>
          <div className="w-full lg:w-1/2">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-5">
              什么是踩蘑菇？
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
              踩蘑菇是一款经典的横版跳跃冒险小游戏，自发布以来深受各年龄段玩家的喜爱。游戏以简单直观的操作和富有挑战性的关卡设计著称——你只需操控角色跳跃、踩踏蘑菇敌人、收集分数，在充满想象力的蘑菇世界中不断前进。
            </p>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              游戏最大的魅力在于"易学难精"：基础操作只需要几分钟就能掌握，但想要冲击排行榜高分、解锁全部隐藏要素、甚至挑战无伤通关，则需要大量的练习和对游戏机制的深入理解。本网站致力于为每一位玩家提供最全面的攻略支持。
            </p>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {[
                { icon: 'ri-gamepad-line', label: '简单易上手' },
                { icon: 'ri-trophy-line', label: '挑战排行榜' },
                { icon: 'ri-map-pin-line', label: '丰富关卡' },
                { icon: 'ri-eye-2-line', label: '隐藏彩蛋' },
                { icon: 'ri-user-star-line', label: '适合全年龄' },
                { icon: 'ri-heart-line', label: '免费畅玩' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-2">
                  <span className="w-8 h-8 flex items-center justify-center rounded-full bg-accent-100">
                    <i className={`${item.icon} text-accent-500 text-sm`}></i>
                  </span>
                  <span className="text-xs md:text-sm text-foreground-700">{item.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}